export const LOCALES = ['fr', 'en'] as const
export type Locale = (typeof LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'fr'

// One entry per locale: native name (a language is always listed in its own
// language) and the ISO 3166 country whose flag the locale switcher shows.
export const LOCALE_META = {
  fr: { name: 'Français', country: 'FR' },
  en: { name: 'English', country: 'GB' },
} as const satisfies Record<Locale, { name: string; country: string }>

export function isLocale(v: string): v is Locale {
  return (LOCALES as readonly string[]).includes(v)
}

export function pickLocale(acceptLanguage: string): Locale {
  const first = acceptLanguage.split(',')[0]?.trim().toLowerCase() ?? ''
  return first.startsWith('en') ? 'en' : DEFAULT_LOCALE
}
